import React from 'react';
import ReportsList from './Components/ReportsList/ReportsList';

const Guides = () => {
	return <ReportsList title={'pages.reports.guides'} url={'/api/reports/guides/'} />;
};

export default Guides;
